import { Component, OnInit } from "@angular/core";
import * as ProgressBar from "progressbar.js";
import { HttpClient } from "@angular/common/http";

declare const stitch: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "my-profile";
  constructor(public http: HttpClient) {}
  ngOnInit(): void {
    this.initStitch();
    this.buildCircleProgressBar(95, "#HTML", "#FCB03C");
    this.buildCircleProgressBar(90, "#Javascript", "#00ff00");
    this.buildCircleProgressBar(75, "#CSS", "#ff9900");
    this.buildCircleProgressBar(90, "#CSharp", "#b300b3");

    this.buildCircleProgressBar(90, "#SQL", "#994d00");
    this.buildCircleProgressBar(85, "#aspcore", "#0066ff");
    this.buildCircleProgressBar(80, "#Angular", "#e60000");
    this.buildCircleProgressBar(65, "#Azure", "#d9d9d9");
    this.buildCircleProgressBar(65, "#aws", "#994d00");

    this.buildProgressBar(80, "#MongoDB", "#00e600");
    this.buildProgressBar(75, "#MySQL", "#00e600");
    this.buildProgressBar(60, "#SSRS", "#ff6633");
    this.buildProgressBar(60, "#SSIS", "#ff6633");
    this.buildProgressBar(50, "#Firestore", "#ff6633");

    this.buildProgressBar(60, "#ec2", "#00e600");
    this.buildProgressBar(60, "#rds", "#00e600");
    this.buildProgressBar(50, "#s3", "#ff6633"); 
    this.buildProgressBar(50, "#lambda", "#ff6633");
    this.buildProgressBar(50, "#codecommit", "#ff6633"); 

    this.buildProgressBar(95, "#webapi", "#00e600");
    this.buildProgressBar(90, "#MatDes", "#00e600");
    this.buildProgressBar(90, "#boostrap", "#00e600");
    this.buildProgressBar(85, "#jwt", "#00e600");
    this.buildProgressBar(85, "#NodeJS", "#00e600");
    this.buildProgressBar(80, "#Typescript", "#00e600");
    this.buildProgressBar(70, "#wcf", "#ff6633");
    this.buildProgressBar(65, "#Knockout", "#ff6633");
    this.buildProgressBar(50, "#Firebase", "#ff6633");
    this.buildProgressBar(40, "#Nativescript", "#ff6633");

    this.buildProgressBar(80, "#AppServices", "#00e600");
    this.buildProgressBar(80, "#ASQLDatabases", "#00e600");
    this.buildProgressBar(75, "#StorageAccounts", "#00e600");
    this.buildProgressBar(70, "#DevOps", "#00e600");
    this.buildProgressBar(65, "#VirtualMachines", "#00e600");
    this.buildProgressBar(60, "#Logic", "#ff6633");
    this.buildProgressBar(55, "#Cognitive", "#ff6633");
    this.buildProgressBar(50, "#Notification", "#ff6633");
    this.buildProgressBar(40, "#factories", "#ff6633");
  }

  initStitch() {
    const client = stitch.Stitch.initializeDefaultAppClient("my-profile-ydbjy");

    const db = client
      .getServiceClient(stitch.RemoteMongoClient.factory, "mongodb-atlas")
      .db("my-profile");

    this.http
      .get("https://www.cloudflare.com/cdn-cgi/trace", { responseType: "text" })
      .toPromise()
      .then((data) => {
        console.log(data.split("\n"));
        const track = {date: new Date()};
        data.split("\n").forEach(item => {
          track[item.split("=")[0]] = item.split("=")[1];
        });
        console.log(track);
        client.auth
          .loginWithCredential(new stitch.AnonymousCredential())
          .then((user) => {
            db.collection("site_access").insertOne(track);
          })
          .catch((err) => {
            console.error(err);
          });
      });
  }

  buildProgressBar(percentage, element, circlecolor) {
    var bar = new ProgressBar.Line(element, {
      strokeWidth: 4,
      easing: "easeInOut",
      duration: 1400,
      color: circlecolor,
      trailColor: "black",
      trailWidth: 1,
      svgStyle: { width: "100px", height: "10px" },
    });

    bar.animate(percentage / 100);
  }

  buildCircleProgressBar(percentage, element, circlecolor) {
    var circle = new ProgressBar.Circle(element, {
      color: circlecolor,
      duration: 3000,
      set: 50,
      easing: "easeInOut",
      step: function (state, circle) {
        var value = Math.round(circle.value() * 100);
        if (value === 0) {
          circle.setText("");
        } else {
          circle.setText(value);
        }
      },
    });

    circle.animate(percentage / 100);
  }
}
